import { useEffect, useMemo, useState } from "react";

export const useSearchableList = ({
  defaultValue,
  autoFocus,
  maxLength,

  onAutoFocus,
  onFocus,
  onBlur,
  onChange,
  
  onFilterChange,
  getOptionDisabled,
  errorOnEmpty,
}) => {
  const [ searchValue, setSearchValue ] = useState(defaultValue);
  const [ hasValueIsUsedError, setUsedValue ] = useState(false);
  const [ focused, setFocused ] = useState(autoFocus);
  const [ hadAutofocus, setHadAutofocus ] = useState(autoFocus);
  const [ hadInteraction, setHadInteraction ] = useState(autoFocus);

  const [ anchor, setAnchor ] = useState(null);
  
  const hasEmptyError = useMemo(() => (
    errorOnEmpty && !searchValue?.length && !hadAutofocus
  ), [ errorOnEmpty, searchValue, hadAutofocus ]);

  useEffect(() => {
    if (autoFocus) {
      setFocused(autoFocus);
      setHadAutofocus(autoFocus);
      onAutoFocus && onAutoFocus();
    }
  }, [autoFocus]);

  useEffect(() => {
    setSearchValue(defaultValue?.replace(/<([.\n])*?>/g, ""));
    setHadInteraction(false);
  }, [defaultValue]);

  useEffect(() => {
    if (focused !== undefined) onFocus && onFocus();
  }, [focused]);

  useEffect(() => {
    if (focused && searchValue.length >= 3)
      onFilterChange && onFilterChange(searchValue);

    if (
      focused &&
      searchValue.length &&
      searchValue !== defaultValue &&
      getOptionDisabled
    )
      setUsedValue(getOptionDisabled(searchValue));
  }, [searchValue]);

  const handleInputChange = (v) => {
    setSearchValue(v.slice(0, maxLength));
    if(!hadInteraction)
      setHadInteraction(true);
  };

  const handleFocus = () => {
    setFocused(true);
  };

  const handleNameAccept = () => {
    if (focused) {
      setFocused(false);
      setHadAutofocus(false);
      setHadInteraction(false);
      
      if(!hasValueIsUsedError && !hasEmptyError && searchValue && searchValue !== defaultValue) {
        onChange && onChange({ name: searchValue }, true);
        return;
      }
      
      if (hasValueIsUsedError && defaultValue) {
        setUsedValue(false);
          setSearchValue(defaultValue);
      } else {
        if(hasEmptyError && defaultValue)
          setSearchValue(defaultValue);
        onBlur && onBlur();
      }
    }
  };

  const looseFocus = () => {
    setFocused(false);
    setHadAutofocus(false);
  };

  const inputProps = {
    ref: setAnchor,
    focused,
    value: searchValue,
    error: hasValueIsUsedError || hasEmptyError,
    onChange: handleInputChange,
    onFocus: handleFocus,
    onAccept: handleNameAccept,
    confirmOnEnter: true,
    acceptOnClickAway: true,
  };

  const containerProps = {
    show: focused,
    anchor: anchor,
  };

  return {
    inputProps,
    containerProps,
    hadAutofocus,
    hadInteraction,
    looseFocus,
  };
};
